<template>
    <div>
       <v-card :color="color">
          <v-card-text>
            <v-layout wrap>
              <span class="pa-3 mt-3" style="font-size:16px;font-weight:400;">{{title}}</span>
              <v-btn-toggle small v-model="toggle_filter" dense mandatory color="info" class="btn-filter-group pa-3">
                  <v-btn class='btn-period' @click="monthlyClick">
                    Monthly
                  </v-btn>

                  <v-btn class='btn-period' @click="quartelyClick">
                    Quartely
                  </v-btn>

                  <v-btn class='btn-period' @click="yearlyClick">
                    Yearly
                  </v-btn>
                </v-btn-toggle>
                <v-autocomplete
                  class="col-md-3 col-sm-12 col-xs-12 pa-3"
                  v-model="selectedFilter.firstFilterId"
                  item-value="id" 
                  item-text="name"
                  :items="firstFilters"
                  :label="firstFilterLabel"
                  hide-details
                  outlined
                  auto-select-first
                  @change="search"
                ></v-autocomplete>
                <v-card
                max-width="330"
                height="180"
                class="summary-card"
                outlined
                v-if="summary && summary.length"
                >
                  <v-card-text>
                    <p class="text-h6 text--primary">
                      {{summaryTitle}}
                    </p>
                    <div class="text--primary" v-for="item, index in summary" :key="index" style="font-size:14px;margin:5px;">
                      {{item.label}}: <strong>{{item.data | thousandSeprator}}</strong>                  
                    </div>
                  </v-card-text>
                </v-card>
            </v-layout>
            <v-row justify="center" align="center" style="margin-top:20px;">
              <v-col cols="12" sm="12" md="9" lg="9" >
                <canvas :id="id" width="500" height="200" ></canvas>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" style="margin-top:20px;margin-bottom:20px;" v-if="detail">
              <v-col cols="12" align="end" sm="12" md="9" lg="9" >
                <v-btn color="info" @click="detailClick">Details</v-btn>
              </v-col>           
            </v-row>
          </v-card-text>
       </v-card>
    </div>
</template>
<script>
import Chart from 'chart.js';
export default {
  name: 'Line-Chart',
  props: {
    id: {type: String},
    title: {type: String},
    filters: {type: Array},
    firstFilters: {type: Array},
    firstFilterLabel: {type: String},
    labels: {type: Array},
    datasets: {type: Array},
    summaryTitle: {type: String},
    summary: {type: Array},
    detail: {type: Boolean},
    color: {type: String},
    yAxes: {type: Object}
  },
  data() {
    return {
      toggle_filter: 0,
      selectedFilter: {
        monthly: true,
        quarterly: false,
        yearly: false,
        firstFilterId: ''
      }
    }
  },
  mounted() {
    this.renderChart()
  },
  watch: {
    labels() {
      this.renderChart()
    },
    datasets() {
      this.renderChart()
    }
  },
  methods: {
    detailClick() {
      this.$emit('detailClick')
    },
    monthlyClick() {
      if (this.selectedFilter.monthly) {
        return;
      }
      this.changePeriodGroup('monthly')
    },
    quartelyClick() {
      if (this.selectedFilter.quarterly) {
        return;
      }
      this.changePeriodGroup('quarterly')
    },
    yearlyClick() {
      if (this.selectedFilter.yearly) {
        return;
      }
      this.changePeriodGroup('yearly')
    },
    changePeriodGroup(period) {
      this.selectedFilter.monthly = (period === 'monthly')
      this.selectedFilter.quarterly = (period === 'quarterly')
      this.selectedFilter.yearly = (period === 'yearly')
      this.search()
    },
    search() {
      this.$emit('searchfilter', this.selectedFilter)
    },
    renderChart() {
      var ctx = document.getElementById(this.id);
      let options = {
        legend: {
          position: 'top'
        }
      }
      if (this.id !== 'spend_avg_per_campaign_chart') {
        options.scales = {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          },
          yAxes: [{
            ticks: {
              min: this.yAxes.min,
              max: this.yAxes.max,
              stepSize: this.yAxes.stepSize
            },
            scaleLabel: {
              display: true,
              labelString: this.yAxes.label
            }
          }]
        }
      }
      const config = {
        type: 'line',
        data: {
          'labels': this.labels,
          'datasets': this.datasets
        },
        options
      };
      if (this.id === 'influencer_line_chart') {
        if (window.influencerChart !== undefined) {
          window.influencerChart.destroy()
        }
        // eslint-disable-next-line
        window.influencerChart = new Chart(ctx, config)
      } else if (this.id === 'spend_avg_per_campaign_chart') {
        if (window.spendAvgPerCampaignChart !== undefined) {
          window.spendAvgPerCampaignChart.destroy()
        }
        // eslint-disable-next-line
        window.spendAvgPerCampaignChart = new Chart(ctx, config)
      } else {
        if (window.clientChart !== undefined) {
          window.clientChart.destroy()
        }
        // eslint-disable-next-line
        window.clientChart = new Chart(ctx, config)
      }
    }
  }
}
</script>
<style scoped>
.btn-filter-group {
  background: none!important;
}
.btn-period {
  height: 56px!important
}
.summary-card {
  margin-left: auto;
  overflow:scroll;
  overflow-x:auto;
}
</style>



// WEBPACK FOOTER //
// Line.vue?7fd046ad